// R113 #1 (Jesse: "per BED not just per bedroom"): the per-size PAR split a
// per_bed rule with by_size carries — "6 King · 3 Queen" — rendered the same
// way on every PAR consumer (HK stocking list, inspection count, onboarding
// inventory chip, readiness-guide card). Returns plain text; callers escape.
// When rounding each size up adds to more than the plain expected count,
// both are shown ("… = 9 by size") so neither number is a surprise.
const LABEL: Record<string, string> = { king: 'King', queen: 'Queen', full: 'Full', twin: 'Twin', crib: 'Crib', unknown: 'unsized' };

export function parSizesText(it: any): string {
  const sizes = Array.isArray(it && it.sizes) ? it.sizes.filter((s: any) => s && s.size && s.count != null) : [];
  if (!sizes.length) return '';
  let txt = sizes.map((s: any) => `${s.count} ${LABEL[String(s.size)] || String(s.size)}`).join(' · ');
  if (it.expected_by_size != null && it.expected != null && it.expected_by_size !== it.expected) txt += ` = ${it.expected_by_size} by size`;
  return txt;
}
